import { regex } from './regex'

export default (textURL) => {
  return regex.is.url.test(textURL)
}
